import * as React from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useGetLastConversationIdQuery } from "@/modules/chat/chat.api";
import { useQaWorkerWarmup } from "@/modules/chat/hooks/useQaWorkerWarmup";

export const ChatEmptyView: React.FC = () => {
  const { systemId = "" } = useParams<{ systemId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  useQaWorkerWarmup();
  const { data } = useGetLastConversationIdQuery(systemId, {
    skip: !systemId,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  React.useEffect(() => {
    if (data) {
      navigate(`/chat/${systemId}/${data}`, {
        replace: true,
        state: location.state,
      });
    }
  }, [data, navigate, systemId, location.state]);

  return null;
};
